import type en from '../en/rental'
import type { Translation } from '../types'

/** Rental */
const rental: Translation<typeof en> = {
  "rental.title": "Vermietung",
  "rental.subtitle": "Bestand, Planung, Veranstaltungen und Einkauf",
  "rental.sections": "Bereiche der Vermietung",
  "rental.tab.planning": "Planung",
  "rental.tab.events": "Veranstaltungen",
  "rental.tab.customers": "Kunden",
  "rental.tab.stock": "Bestand",
  "rental.tab.suppliers": "Lieferanten",
  "rental.tab.purchasing": "Einkauf",
  "rental.search": "Suchen",
  "rental.notes": "Anmerkungen",
  "rental.details": "Angaben",
  "rental.saveFailed": "Speichern hat nicht funktioniert",
  "rental.amountInvalid": "Ein Betrag ist keine Zahl wie 12,50",
  "rental.percentInvalid": "Ein Prozentsatz ist eine Zahl von 0 bis 100",
  "rental.stock.sections": "Bereiche des Bestands",
  "rental.stock.articles": "Artikel",
  "rental.stock.items": "Inventar",
  "rental.stock.warehouses": "Lager",
  "rental.stock.transfers": "Umlagerungen",
  "rental.stock.categories": "Kategorien",
  "rental.article.add": "Artikel hinzufügen",
  "rental.article.edit": "Artikel bearbeiten",
  "rental.article.save": "Artikel speichern",
  "rental.article.saved": "Artikel gespeichert",
  "rental.article.deleted": "Artikel gelöscht",
  "rental.article.deleteConfirm": "Den Artikel {name} löschen? Ein Artikel mit Exemplaren, Bestand oder Positionen kann nicht gelöscht werden: deaktivieren Sie ihn stattdessen.",
  "rental.article.empty": "Noch keine Artikel",
  "rental.article.sku": "Artikelnummer",
  "rental.article.name": "Name",
  "rental.article.description": "Beschreibung",
  "rental.article.category": "Kategorie",
  "rental.article.allCategories": "Alle Kategorien",
  "rental.article.showInactive": "Inaktive zeigen",
  "rental.article.inactive": "Inaktiv",
  "rental.article.active": "Aktiv (kann auf Veranstaltungen)",
  "rental.article.perItem": "Einzeln (Seriennummer)",
  "rental.article.bulk": "Menge (Schüttgut)",
  "rental.article.dayPrice": "Tagespreis",
  "rental.article.weekendPrice": "Wochenendpreis",
  "rental.article.weekPrice": "Wochenpreis",
  "rental.article.fromDayPrice": "Leer: aus dem Tagespreis",
  "rental.article.vatRate": "MwSt. (%)",
  "rental.article.vatDefault": "Leer: der Standardsatz des Unternehmens",
  "rental.article.vatDefaultShort": "Standard",
  "rental.article.purchasePrice": "Einkaufspreis",
  "rental.article.externalCode": "Code in der Rechnungssoftware",
  "rental.article.prices": "Preise ohne MwSt.",
  "rental.article.stock": "Bestand",
  "rental.article.noStock": "Kein Bestand",
  "rental.item.add": "Exemplar hinzufügen",
  "rental.item.save": "Exemplar speichern",
  "rental.item.saved": "Exemplar gespeichert",
  "rental.item.empty": "Keine Exemplare",
  "rental.item.serial": "Seriennummer",
  "rental.item.mac": "MAC-Adresse",
  "rental.item.tag": "Tag",
  "rental.item.tagHint": "Der NFC-Tag oder QR-Code (vorerst optional)",
  "rental.item.article": "Artikel",
  "rental.item.warehouse": "Lager",
  "rental.item.status": "Status",
  "rental.item.statusOf": "Status von {name}",
  "rental.item.historyOf": "Verlauf von {name}",
  "rental.item.allArticles": "Alle Artikel",
  "rental.item.allWarehouses": "Alle Lager",
  "rental.item.allStatuses": "Jeder Status",
  "rental.bulk.title": "Menge pro Lager",
  "rental.bulk.count": "Zählen",
  "rental.bulk.countOf": "{name} zählen",
  "rental.bulk.counted": "Gezählt",
  "rental.bulk.note": "Warum (optional)",
  "rental.bulk.save": "Zählung speichern",
  "rental.bulk.saved": "Zählung gespeichert",
  "rental.bulk.quantity": "Menge",
  "rental.bulk.packed": "Davon in Cases",
  "rental.warehouse.add": "Lager hinzufügen",
  "rental.warehouse.edit": "Lager bearbeiten",
  "rental.warehouse.editOf": "{name} bearbeiten",
  "rental.warehouse.save": "Lager speichern",
  "rental.warehouse.saved": "Lager gespeichert",
  "rental.warehouse.deleted": "Lager gelöscht",
  "rental.warehouse.deleteOf": "{name} löschen",
  "rental.warehouse.deleteConfirm": "Das Lager {name} löschen? Nur ein leeres Lager ohne Veranstaltungen kann gelöscht werden.",
  "rental.warehouse.empty": "Noch keine Lager: fügen Sie das erste hinzu",
  "rental.warehouse.name": "Name",
  "rental.warehouse.address": "Adresse",
  "rental.warehouse.default": "Hauptlager",
  "rental.warehouse.makeDefault": "Zum Hauptlager machen",
  "rental.warehouse.makeDefaultOf": "{name} zum Hauptlager machen",
  "rental.transfer.add": "Neue Umlagerung",
  "rental.transfer.save": "Umlagern",
  "rental.transfer.done": "Umgelagert",
  "rental.transfer.empty": "Noch keine Umlagerungen",
  "rental.transfer.from": "Von",
  "rental.transfer.to": "Nach",
  "rental.transfer.when": "Wann",
  "rental.transfer.fromTo": "Von → nach",
  "rental.transfer.what": "Was",
  "rental.transfer.by": "Von",
  "rental.transfer.bulk": "Mengen",
  "rental.transfer.noItems": "Keine losen Exemplare oder Einheiten in diesem Lager (der Inhalt einer Einheit wird mit ihr umgelagert)",
  "rental.transfer.summary": "Exemplare und Einheiten: {items} · Menge: {bulk}",
  "rental.category.add": "Kategorie hinzufügen",
  "rental.category.name": "Name der Kategorie",
  "rental.category.saved": "Kategorie gespeichert",
  "rental.category.deleted": "Kategorie gelöscht",
  "rental.category.renameOf": "{name} umbenennen",
  "rental.category.deleteOf": "{name} löschen",
  "rental.category.deleteConfirm": "Die Kategorie {name} löschen? Ihre Artikel bleiben, ohne Kategorie.",
  "rental.category.empty": "Noch keine Kategorien",
  "rental.history.title": "Verlauf",
  "rental.history.empty": "Bisher ist nichts geschehen",
  "rental.history.quantity": { one: "{count} Stück", other: "{count} Stück" },
  "rental.history.item.status": "Status geändert",
  "rental.history.bulk.count": "Gezählt",
  "rental.history.transfer": "Umlagerung",
  "rental.history.receipt": "Erhalten",
  "rental.history.subrental.return": "An den Lieferanten zurück",
  "rental.status.IN_STOCK": "Auf Lager",
  "rental.status.AT_EVENT": "Bei einer Veranstaltung",
  "rental.status.IN_REPAIR": "In Reparatur",
  "rental.status.LOST": "Verloren",
  "rental.status.RETIRED": "Ausgemustert",
  "rental.status.RETURNED": "An den Lieferanten zurück",
  "rental.status.REQUESTED": "Angefragt",
  "rental.status.RESERVED": "Reserviert",
  "rental.status.CONFIRMED": "Bestätigt",
  "rental.status.CLOSED": "Abgeschlossen",
  "rental.status.CANCELLED": "Storniert",
  "rental.status.DRAFT": "Entwurf",
  "rental.status.AWAITING_APPROVAL": "Wartet auf Freigabe",
  "rental.status.SENT": "Gesendet",
  "rental.status.PARTLY_RECEIVED": "Teilweise erhalten",
  "rental.status.RECEIVED": "Erhalten",
  "rental.customer.add": "Kunden hinzufügen",
  "rental.customer.edit": "Kunden bearbeiten",
  "rental.customer.save": "Kunden speichern",
  "rental.customer.saved": "Kunde gespeichert",
  "rental.customer.deleted": "Kunde gelöscht",
  "rental.customer.deleteConfirm": "Den Kunden {name} löschen? Ein Kunde mit Veranstaltungen kann nicht gelöscht werden.",
  "rental.customer.empty": "Noch keine Kunden",
  "rental.customer.name": "Name",
  "rental.customer.contact": "Ansprechpartner",
  "rental.customer.email": "E-Mail",
  "rental.customer.phone": "Telefon",
  "rental.customer.address": "Adresse",
  "rental.customer.vatNumber": "USt-IdNr.",
  "rental.customer.externalRef": "Code in der Rechnungssoftware",
  "rental.customer.noEvents": "Noch keine Veranstaltungen",
  "rental.supplier.add": "Lieferanten hinzufügen",
  "rental.supplier.edit": "Lieferanten bearbeiten",
  "rental.supplier.save": "Lieferanten speichern",
  "rental.supplier.saved": "Lieferant gespeichert",
  "rental.supplier.deleted": "Lieferant gelöscht",
  "rental.supplier.deleteConfirm": "Den Lieferanten {name} löschen? Ein Lieferant mit Bestellungen kann nicht gelöscht werden.",
  "rental.supplier.empty": "Noch keine Lieferanten",
  "rental.supplier.name": "Name",
  "rental.supplier.contact": "Ansprechpartner",
  "rental.supplier.email": "E-Mail",
  "rental.supplier.phone": "Telefon",
  "rental.supplier.address": "Adresse",
  "rental.supplier.vatNumber": "USt-IdNr.",
  "rental.supplier.language": "Sprache",
  "rental.supplier.languageHint": "Bestellschreiben und Mails an ihn sind in dieser Sprache",
  "rental.supplier.orders": "Bestellungen und Anfragen",
  "rental.supplier.noOrders": "Noch keine Bestellungen oder Anfragen",
  "rental.settings.prices": "Preise",
  "rental.settings.method": "Wie Preise berechnet werden",
  "rental.settings.method.STAFFEL": "Ein Tagespreis mit Staffel",
  "rental.settings.method.STAFFEL.hint": "Der Tagespreis mal dem Faktor für die Anzahl der Tage",
  "rental.settings.method.FIXED": "Feste Tages-, Wochenend- und Wochenpreise",
  "rental.settings.method.FIXED.hint": "Innerhalb eines Wochenendes (Freitag 12:00 bis Montag 12:00) der Wochenendpreis; sonst Wochen und Tage, die Tage nie mehr als eine Woche",
  "rental.settings.staffel": "Die Staffel",
  "rental.settings.from": "Ab",
  "rental.settings.days": "Tage",
  "rental.settings.daysTimes": "Tagen:",
  "rental.settings.factor": "Faktor",
  "rental.settings.dayPrice": "× Tagespreis",
  "rental.settings.addRow": "Zeile hinzufügen",
  "rental.settings.removeRow": "Diese Zeile entfernen",
  "rental.settings.extraDay": "Jeder Tag nach der letzten Zeile fügt hinzu (× Tagespreis)",
  "rental.settings.staffelInvalid": "Jede Staffelzeile braucht ganze Tage und einen Faktor wie 1,5",
  "rental.settings.vat": "Standard-MwSt.-Satz (%)",
  "rental.settings.currency": "Währung",
  "rental.settings.fourEyes": "Jemand anderes muss freigeben",
  "rental.settings.fourEyesHint": "Wer eine Bestellung oder Zumietanfrage anlegt oder einreicht, kann sie nicht freigeben",
  "rental.settings.letters": "Auf Schreiben an Lieferanten",
  "rental.settings.lettersHint": "Das Logo des Unternehmens steht oben, wenn es eins hat",
  "rental.settings.letterName": "Firmenname",
  "rental.settings.letterAddress": "Adresse",
  "rental.settings.letterVat": "USt-IdNr.",
  "rental.settings.letterCoc": "Handelsregisternummer",
  "rental.settings.letterEmail": "E-Mail",
  "rental.settings.letterPhone": "Telefon",
  "rental.settings.save": "Vermietungseinstellungen speichern",
  "rental.settings.saved": "Vermietungseinstellungen gespeichert",
  "rental.event.add": "Neue Veranstaltung",
  "rental.event.edit": "Veranstaltung bearbeiten",
  "rental.event.save": "Veranstaltung speichern",
  "rental.event.saved": "Veranstaltung gespeichert",
  "rental.event.empty": "Noch keine Veranstaltungen",
  "rental.event.needed": "Wählen Sie den Kunden und den Mietzeitraum",
  "rental.event.name": "Veranstaltung",
  "rental.event.customer": "Kunde",
  "rental.event.rentalStart": "Mietbeginn",
  "rental.event.rentalEnd": "Mietende",
  "rental.event.rentalPeriod": "Mietzeitraum",
  "rental.event.materialPeriod": "Material raus und zurück",
  "rental.event.materialOut": "Material raus",
  "rental.event.materialBack": "Material zurück",
  "rental.event.materialApart": "Material geht früher raus oder kommt später zurück als die Miete",
  "rental.event.warehouse": "Hauptlager",
  "rental.event.homeWarehouse": "Das Hauptlager des Unternehmens",
  "rental.event.site": "Standort",
  "rental.event.externalRef": "Angebotsnummer",
  "rental.event.total": "Gesamt",
  "rental.event.short": "Fehlt",
  "rental.event.reserve": "Reservieren",
  "rental.event.confirm": "Bestätigen",
  "rental.event.close": "Abschließen",
  "rental.event.cancel": "Veranstaltung stornieren",
  "rental.event.reopen": "Wieder öffnen",
  "rental.event.cancelConfirm": "Die Veranstaltung {name} stornieren? Sie hält dann kein Material mehr.",
  "rental.event.statusSaved": "Jetzt: {status}",
  "rental.line.title": "Positionen",
  "rental.line.empty": "Noch keine Positionen: fügen Sie unten einen Artikel hinzu",
  "rental.line.add": "Position hinzufügen",
  "rental.line.save": "Position speichern",
  "rental.line.saved": "Position gespeichert",
  "rental.line.deleted": "Position gelöscht",
  "rental.line.editOf": "Die Position {name} bearbeiten",
  "rental.line.deleteOf": "Die Position {name} löschen",
  "rental.line.deleteConfirm": "Die Position {name} löschen?",
  "rental.line.quantity": "Menge",
  "rental.line.unitPrice": "Einzelpreis",
  "rental.line.calculated": "berechnet {price}",
  "rental.line.customPrice": "Eigener Einzelpreis",
  "rental.line.customHint": "Leer: der berechnete {price}",
  "rental.line.availability": "Frei und fehlend",
  "rental.line.shortBy": "Fehlt {count}",
  "rental.line.free": "Frei: {free} (wenn offene Angebote entfallen: {fall})",
  "rental.line.subrented": "{count} zugemietet",
  "rental.line.expected": "{count} erwartet",
  "rental.line.requested": "{count} angefragt, noch nicht bestätigt",
  "rental.line.transferFrom": "Umlagern aus {name}",
  "rental.discount.title": "Rabatt",
  "rental.discount.type": "Art",
  "rental.discount.none": "Keiner",
  "rental.discount.percent": "Ein Prozentsatz",
  "rental.discount.amount": "Ein Betrag",
  "rental.discount.value": "Betrag",
  "rental.discount.save": "Rabatt speichern",
  "rental.discount.saved": "Rabatt gespeichert",
  "rental.totals.title": "Summen",
  "rental.totals.subtotal": "Zwischensumme",
  "rental.totals.discount": "Rabatt",
  "rental.totals.vat": "MwSt. {rate}",
  "rental.totals.total": "Gesamt",
  "rental.planning.table": "Planung",
  "rental.planning.span": "Zeitraum",
  "rental.planning.day": "Tag",
  "rental.planning.week": "Woche",
  "rental.planning.month": "Monat",
  "rental.planning.date": "Datum",
  "rental.planning.previous": "Zurück",
  "rental.planning.next": "Weiter",
  "rental.planning.today": "Heute",
  "rental.planning.cell": "{article}, {day}: {free} frei, {held} belegt",
  "rental.planning.cellShort": "— {count} fehlen",
  "rental.planning.shortEvents": "Veranstaltungen mit Fehlbestand",
  "rental.planning.noneShort": "In diesem Zeitraum fehlt nichts",
  "rental.planning.owned": "Eigener Bestand",
  "rental.planning.subrented": "Zugemietet",
  "rental.planning.expected": "Erwartet",
  "rental.planning.from": "Ab",
  "rental.planning.held": "Belegt",
  "rental.planning.free": "Frei",
  "rental.order.purchaseOrders": "Bestellungen",
  "rental.order.subRentals": "Zumieten",
  "rental.order.purchaseOrder": "Bestellung",
  "rental.order.subRental": "Zumiete",
  "rental.order.newPurchase": "Neue Bestellung",
  "rental.order.newSubRental": "Neue Zumiete",
  "rental.order.savePurchase": "Bestellung speichern",
  "rental.order.saveSubRental": "Zumiete speichern",
  "rental.order.purchaseSaved": "Bestellung gespeichert",
  "rental.order.subRentalSaved": "Zumiete gespeichert",
  "rental.order.edit": "{number} bearbeiten",
  "rental.order.editShort": "Bearbeiten",
  "rental.order.deleted": "Gelöscht",
  "rental.order.deleteConfirm": "Den Entwurf {number} löschen?",
  "rental.order.empty": "Hier ist noch nichts",
  "rental.order.number": "Nummer",
  "rental.order.supplier": "Lieferant",
  "rental.order.warehouse": "Empfangendes Lager",
  "rental.order.expected": "Erwartete Lieferung",
  "rental.order.window": "Mietzeitraum",
  "rental.order.from": "Ab",
  "rental.order.to": "Bis",
  "rental.order.forEvent": "Für die Veranstaltung",
  "rental.order.notes": "Anmerkungen für den Lieferanten",
  "rental.order.supplierCode": "Artikelnummer des Lieferanten",
  "rental.order.unitPrice": "Einzelpreis",
  "rental.order.unitCost": "Kosten pro Stück",
  "rental.order.received": "Bisher erhalten",
  "rental.order.items": "Erfasste Exemplare",
  "rental.order.madeBy": "Angelegt von",
  "rental.order.askedBy": "Freigabe angefragt von",
  "rental.order.approvedBy": "Freigegeben von",
  "rental.order.sentTo": "Gesendet an",
  "rental.order.askApproval": "Freigabe anfragen",
  "rental.order.approve": "Freigeben",
  "rental.order.sendAgain": "Erneut senden",
  "rental.order.recordConfirmation": "Bestätigung erfassen",
  "rental.order.registerItems": "Exemplare erfassen",
  "rental.order.saveItems": "Exemplare speichern",
  "rental.order.itemsSaved": "Exemplare erfasst",
  "rental.order.allRegistered": "Alle erfasst",
  "rental.order.close": "Zumiete abschließen",
  "rental.order.closeConfirm": "Abschließen? Die erfassten Exemplare gehen an den Lieferanten zurück.",
  "rental.order.receive": "Empfangen",
  "rental.order.receiveLine": "{name}: {received} von {quantity} erhalten, jetzt",
  "rental.order.serialOf": "Seriennummer {n}",
  "rental.order.saveReceipt": "Eingang speichern",
  "rental.order.receiptSaved": "Eingang gespeichert",
  "rental.order.newExpected": "Neuer erwarteter Tag",
  "rental.order.saveExpected": "Tag speichern",
  "rental.order.expectedSaved": "Erwarteter Tag gespeichert",
  "rental.order.cancelOrder": "Bestellung stornieren",
  "rental.order.cancelRequest": "Anfrage stornieren",
  "rental.order.cancelConfirm": "{number} stornieren?",
  "rental.order.pdf": "PDF herunterladen",
  "rental.order.waiting": "Wartet auf jemanden, der freigeben darf",
  "rental.order.someoneElse": "Jemand anderes muss dies freigeben",
  "rental.order.notSent": "Freigegeben, nicht gesendet",
  "rental.order.notSentReason": "Freigegeben, aber die Mail an den Lieferanten wurde nicht gesendet: {reason}",
  "rental.order.done.request-approval": "Zur Freigabe gegeben",
  "rental.order.done.approve": "Freigegeben und gesendet",
  "rental.order.done.send": "An den Lieferanten gesendet",
  "rental.order.done.cancel": "Storniert",
  "rental.order.done.confirm": "Bestätigung erfasst",
  "rental.order.done.close": "Abgeschlossen: die Exemplare sind zurück",
  "rental.order.byHandHint": "Laden Sie das PDF herunter und senden Sie es selbst an den Lieferanten; markieren Sie die Bestellung danach als gesendet.",
  "rental.order.markSent": "Als gesendet markieren",
  "rental.order.markSentConfirm": "{number} als gesendet markieren? Tun Sie das, sobald der Lieferant das Schreiben hat.",
  "rental.order.done.mark-sent": "Als gesendet markiert",
  "rental.order.sentByHand": "Von Hand, markiert von {name} · {when}",
  "rental.article.kind": "Art",
  "rental.article.kit": "Kit",
  "rental.article.container": "Case",
  "rental.article.kindHint.ITEM": "Jedes Exemplar hat eine eigene Seriennummer oder Kennung",
  "rental.article.kindHint.BULK": "Gezählt, nicht einzeln (Kabel, Adapter)",
  "rental.article.kindHint.KIT": "Bei der Vermietung aus anderen Artikeln zusammengestellt (Rezept); kein eigener Bestand",
  "rental.article.kindHint.CONTAINER": "Ein Case oder Set, dessen Einheiten andere Artikel enthalten (jede Einheit hat einen eigenen Code)",
  "rental.kit.noStock": "Ein Kit hat keinen eigenen Bestand: Bei der Vermietung wird es aus seinen Teilen zusammengestellt.",
  "rental.item.kind": "Art",
  "rental.item.allKinds": "Exemplare und Einheiten",
  "rental.item.kindPlain": "Exemplare",
  "rental.item.kindPieces": "Einheiten von Cases",
  "rental.item.piece": "In Einheit",
  "rental.item.device": "Gerät",
  "rental.recipe.title": "Rezept",
  "rental.recipe.kitHint": "Was ein Kit enthält. Eine Veranstaltungsposition mit N Kits reserviert jedes Teil N-mal.",
  "rental.recipe.containerHint": "Was jede Einheit enthalten soll. Eine Einheit mit anderem Inhalt wird als unvollständig angezeigt.",
  "rental.recipe.empty": "Noch keine Teile",
  "rental.recipe.part": "Teil",
  "rental.recipe.quantity": "Menge",
  "rental.recipe.add": "Teil hinzufügen",
  "rental.recipe.removeOf": "{name} aus dem Rezept entfernen",
  "rental.recipe.saved": "Rezept gespeichert",
  "rental.piece.title": "Einheiten",
  "rental.piece.add": "Einheit hinzufügen",
  "rental.piece.edit": "Einheit bearbeiten",
  "rental.piece.save": "Einheit speichern",
  "rental.piece.saved": "Einheit gespeichert",
  "rental.piece.code": "Code",
  "rental.piece.contents": "Inhalt",
  "rental.piece.empty": "Noch keine Einheiten",
  "rental.piece.complete": "Vollständig",
  "rental.piece.incomplete": "Unvollständig",
  "rental.piece.notRecipe": "Nicht wie im Rezept:",
  "rental.piece.missing": "fehlt: {count} × {name}",
  "rental.piece.extra": "zu viel: {count} × {name}",
  "rental.piece.nothing": "Leer",
  "rental.piece.addItem": "Exemplar hinzufügen",
  "rental.piece.addBulk": "Menge hinzufügen",
  "rental.piece.addDevice": "Gerät hinzufügen",
  "rental.piece.addOne": "Hinzufügen",
  "rental.piece.item": "Exemplar",
  "rental.piece.noItems": "Keine losen, vorrätigen Exemplare in diesem Lager",
  "rental.piece.takeOut": "Herausnehmen",
  "rental.piece.takeOutOf": "{name} herausnehmen",
  "rental.piece.contentsSaved": "Inhalt gespeichert",
  "rental.device.search": "Seriennummer, MAC oder Name",
  "rental.device.searchHint": "Unter den Geräten des Dashboards an den Standorten, die Sie sehen dürfen",
  "rental.device.none": "Kein Gerät gefunden",
  "rental.device.pick": "Wählen",
  "rental.device.pickOf": "{name} wählen",
  "rental.device.inInventory": "Bereits im Inventar",
  "rental.device.takenByOther": "Mit einem anderen Exemplar verknüpft",
  "rental.device.other": "Anderes Gerät",
  "rental.device.article": "Artikel des Exemplars",
  "rental.device.articleHint": "Noch nicht im Inventar: Es wird ein Exemplar dieses Artikels",
  "rental.device.hidden": "An einem Standort, den Sie nicht sehen",
  "rental.device.tie": "Mit Gerät verknüpfen",
  "rental.device.tieOf": "{name} mit einem Gerät verknüpfen",
  "rental.device.tied": "Gerät verknüpft",
  "rental.device.untie": "Gerät trennen",
  "rental.device.untieOf": "Gerät von {name} trennen",
  "rental.device.untieConfirm": "Das Gerät von {name} trennen? Das Exemplar bleibt im Inventar.",
  "rental.device.untied": "Gerät getrennt",
  "rental.line.incomplete": { one: "{count} der freien Einheiten ist unvollständig", other: "{count} der freien Einheiten sind unvollständig" },
  "rental.line.perKit": "{count} pro Kit",
  "rental.planning.kitDay": "Ein Kit hat keinen eigenen Bestand: Das sind die Kits, die seine Teile zum niedrigsten Zeitpunkt des Tages erlauben.",
  "rental.order.expectedHint": "Gilt ab Beginn dieses Tages als erwartet",
  "rental.recipe.quantityOf": "Menge von {name}",
  "rental.item.kindItem": "Exemplar",
  "rental.device.lastSeen": "Zuletzt gesehen {when}",
  "rental.history.item.piece.in": "In eine Einheit gelegt",
  "rental.history.item.piece.out": "Aus einer Einheit genommen",
  "rental.history.bulk.piece": "Menge in einer Einheit",
  "rental.history.device.tie": "Mit Gerät verknüpft",
  "rental.history.device.untie": "Gerät getrennt",
  "rental.event.comment": "Kommentar",
  "rental.event.commentPlaceholder": "Eine Notiz für alle bei dieser Veranstaltung: Kunde, Planer, Techniker",
  "rental.event.commentBy": "Zuletzt geändert von {name}, {when}",
  "rental.event.saveComment": "Kommentar speichern",
  "rental.event.commentSaved": "Kommentar gespeichert",
  "rental.load.title": "Laden",
  "rental.load.scan": "Code scannen oder eintippen",
  "rental.load.scanHint": "Ein Etikett, Stückcode, eine Seriennummer oder MAC: Ein Scanner tippt sie und drückt Enter",
  "rental.load.mode": "Was ein Scan tut",
  "rental.load.modeLoad": "Laden",
  "rental.load.modeReturn": "Zurück: {status}",
  "rental.load.loaded": "Geladen: {name}",
  "rental.load.returned": "Zurück: {name}",
  "rental.load.failed": "Nicht geladen",
  "rental.load.returnFailed": "Nicht zurückgenommen",
  "rental.load.count": "{out} von {quantity} unterwegs",
  "rental.load.byHand": "Von Hand hinzufügen",
  "rental.load.byHandOf": "Von Hand hinzufügen: {name}",
  "rental.load.empty": "Noch nichts geladen",
  "rental.load.out": "Unterwegs",
  "rental.load.when": "{when} · {who}",
  "rental.load.return": "Zurücknehmen",
  "rental.load.returnOf": "{name} zurücknehmen",
  "rental.load.part": "Teil des Kits",
  "rental.load.choose": "Artikel oder Stück",
  "rental.load.none": "Davon ist im Lager der Veranstaltung nichts frei",
  "rental.load.quantity": "Menge",
  "rental.load.load": "Laden",
  "rental.load.missing": "Fehlt im Stück (verloren)",
  "rental.load.cameBack": "Zurückgekommen",
  "rental.load.cameBackHint": "Von {count} unterwegs; der Rest wird als verloren gebucht",
  "rental.settings.archiveDays": "Veranstaltungsstandort nach dem Abschluss behalten (Tage)",
  "rental.settings.archiveDaysHint": "Archiviert, dann nach so vielen Tagen entfernt (1–3650)",
  "rental.load.cameBackOf": "{back} von {out} zurück",
  "rental.bulk.out": "Davon bei Veranstaltungen",
  "rental.bulk.countedHint": "Was jetzt in diesem Lager ist, auch in Koffern; was bei Veranstaltungen ist, wird hinzugerechnet",
  "rental.people.title": "Kundenpersonen",
  "rental.people.hint": "Personen dieses Kunden, die sich anmelden, um ihre Veranstaltungen zu sehen: die Termine, die Geräte vor Ort und ihren Zustand sowie den Kommentar",
  "rental.people.email": "E-Mail-Adresse",
  "rental.people.name": "Name (optional)",
  "rental.people.only": "Nur während der Veranstaltung",
  "rental.people.onlyHint": "Die Anmeldung ist nur von der Materialausgabe bis zur Materialrückgabe einer ihrer Veranstaltungen möglich",
  "rental.people.onlyFixed": "Sie haben es selbst, daher haben es auch die Personen, die Sie einladen",
  "rental.people.main": "Hauptkontakt",
  "rental.people.mainHint": "Darf andere Personen dieses Kunden einladen und entfernen",
  "rental.people.invite": "Einladen",
  "rental.people.invited": "Einladung an {email} gesendet",
  "rental.people.notSent": "{email} wurde hinzugefügt, aber die E-Mail konnte nicht gesendet werden",
  "rental.people.none": "Noch niemand dieses Kunden hat ein Konto",
  "rental.people.pending": "Eingeladen — noch kein Passwort",
  "rental.people.invitedBy": "Eingeladen von {name}, {when}",
  "rental.people.makeMain": "Zum Hauptkontakt machen",
  "rental.people.remove": "Entfernen",
  "rental.people.removeOf": "{name} entfernen",
  "rental.people.removeConfirm": "Den Zugang von {name} entfernen? Diese Person kann sich dann nicht mehr bei den Veranstaltungen dieses Kunden anmelden.",
  "rental.people.removed": "Zugang entfernt",
  "rental.people.saved": "Gespeichert",
  "rental.people.failed": "Nicht gespeichert",
  "rental.portal.myEvents": "Meine Veranstaltungen",
  "rental.portal.people": "Personen",
  "rental.portal.nav": "Kundenansicht",
  "rental.portal.elsewhere": "Wechseln",
  "rental.portal.noEvents": "Noch keine Veranstaltungen anzuzeigen",
  "rental.portal.noSite": "Diese Veranstaltung hat keinen Standort mehr",
  "rental.portal.viewAsClient": "Als Kunde ansehen",
  "rental.portal.previewBar": "Ansicht als Kundenpersonen von {customer} — nur lesen",
  "rental.portal.previewBarNobody": "Was die Kundenpersonen von {customer} sehen werden, sobald sie eingeladen sind — nur lesen",
  "rental.portal.backToEvent": "Zurück zur Veranstaltung",
  "rental.portal.hiddenRequested": "Der Kunde sieht diese Veranstaltung nicht: Sie ist angefragt",
  "rental.portal.hiddenCancelled": "Der Kunde sieht diese Veranstaltung nicht: Sie ist abgesagt",
  "rental.portal.account": "Mein Konto",
  "rental.category.nameNeeded": "Geben Sie zuerst einen Namen für die Kategorie ein",
  "rental.portal.devBanner": "Dieses Produkt befindet sich noch in aktiver Entwicklung und ist offen für Feedback",
  "rental.item.addHow": "Wie hinzufügen",
  "rental.item.fromDashboard": "Aus dem Dashboard",
  "rental.item.byHand": "Von Hand",
  "rental.item.brand": "Marke",
  "rental.item.allBrands": "Alle Marken",
  "rental.item.browseQ": "Name, Seriennummer oder MAC",
  "rental.item.browseHint": "Ein Teil genügt, etwa RX",
  "rental.item.found": { one: "{count} Gerät gefunden", other: "{count} Geräte gefunden" },
  "rental.item.tooMany": "Die ersten {shown} von {total} angezeigt: Schränken Sie den Filter für den Rest ein",
  "rental.item.selectAll": "Alle auswählen ({count})",
  "rental.item.selectNone": "Auswahl aufheben",
  "rental.item.addCount": { one: "{count} Exemplar hinzufügen", other: "{count} Exemplare hinzufügen" },
  "rental.item.addedMany": { one: "{count} Exemplar hinzugefügt", other: "{count} Exemplare hinzugefügt" },
  "rental.item.chooseDevices": "Kreuzen Sie zuerst die Geräte an, die Sie hinzufügen möchten",
  "rental.item.remove": "Entfernen",
  "rental.item.removeOf": "{name} entfernen",
  "rental.item.removeConfirm": "{name} entfernen? Ein Artikel, der nie bei einer Veranstaltung war, wird gelöscht; einer, der dort war, wird ausgemustert und behält seinen Verlauf.",
  "rental.item.deleted": "Artikel gelöscht",
  "rental.item.retiredDone": "Artikel ausgemustert: sein Verlauf bleibt erhalten",
  "rental.item.showRetired": "Ausgemusterte anzeigen",
  "rental.history.item.delete": "Artikel gelöscht",
  "rental.event.remove": "Veranstaltung entfernen",
  "rental.event.removeConfirm": "Die Veranstaltung {name} entfernen? Ihre Positionen, was hinausging und zurückkam, ihr Standort, die Kommentare zu Geräten und die Diagramme werden endgültig entfernt. Zumietungen dafür bleiben, ohne die Veranstaltung.",
  "rental.event.removed": "Veranstaltung entfernt",
  "rental.event.removeFailed": "Die Veranstaltung wurde nicht entfernt",
  "rental.event.removableFrom": "Kann ab {date} entfernt werden",
  "rental.portal.push": "Push-Mitteilung, wenn ein Gerät meiner Veranstaltung offline geht",
  "rental.portal.pushNeedsApp": "Dafür ist die Velanox-App nötig",
  "rental.portal.pushRefused": "Push-Mitteilungen wurden auf diesem Telefon nicht erlaubt",
  "rental.scan.unsentConfirm": {"one": "1 Scan wurde nicht gesendet. Trotzdem abmelden? Er geht dann verloren.", "other": "{count} Scans wurden nicht gesendet. Trotzdem abmelden? Sie gehen dann verloren."},
  "rental.scan.summaryTitle": "Scans gesendet",
  "rental.scan.summary": "{loaded} geladen, {returned} zurückgegeben, {refused} abgelehnt",
  "rental.scan.unknownCount": {"one": "1 Code gehörte zu nichts", "other": "{count} Codes gehörten zu nichts"},
  "rental.scan.dismiss": "Schließen",
  "rental.scan.open": "Scannen",
  "rental.scan.nfc": "NFC",
  "rental.scan.title": "Scannen für {name}",
  "rental.scan.torch": "Licht",
  "rental.scan.done": "Fertig",
  "rental.scan.sending": "Wird gesendet…",
  "rental.scan.waiting": "Wartet auf die Verbindung",
  "rental.scan.unknown": "gehört zu nichts",
  "rental.scan.loadedRow": "{name} · geladen",
  "rental.scan.returnedRow": "{name} · zurückgegeben",
  "rental.scan.noCamera": "Die Kamera ist für die App nicht erlaubt: erlauben Sie sie in den Einstellungen des Telefons",
  "rental.scan.hint": "Halten Sie Codes ins Bild",
  "rental.scan.hintNfc": "Halten Sie Codes ins Bild oder einen Tag an das Telefon",
  "rental.scan.nfcPrompt": "Halten Sie einen Tag an die Oberseite des iPhones",
  "rental.tag.of": "Tag von {name}",
  "rental.tag.save": "Tag speichern",
  "rental.tag.hold": "Halten Sie den Tag an das Telefon",
  "rental.tag.writeFailed": "Der Tag konnte nicht beschrieben werden: halten Sie ihn ruhig und versuchen Sie es erneut",
  "rental.tag.scanTitle": "Ein Etikett scannen",
  "rental.tag.scanHint": "Halten Sie den Code des Etiketts ins Bild",
  "rental.tag.none": "Kein Artikel hat diesen Tag",
  "rental.tag.looking": "Der Tag wird gesucht…",
  "rental.scan.sameItem": "derselbe Artikel, bereits gezählt",
  "rental.scan.unsentConfirmServer": {"one": "1 Scan wurde nicht gesendet. Trotzdem einen anderen Server wählen? Er geht dann verloren.", "other": "{count} Scans wurden nicht gesendet. Trotzdem einen anderen Server wählen? Sie gehen dann verloren."},
  "rental.people.clientExport": "Kunden dürfen exportieren",
  "rental.people.clientExportHint": "Die Personen des Kunden dürfen diese Veranstaltung von ihrer Seite herunterladen: die Geräte mit ihren Notizen, die Diagramme und die Personenliste",
  "rental.people.exportOn": "Kunden dürfen diese Veranstaltung exportieren",
  "rental.people.exportOff": "Kunden dürfen diese Veranstaltung nicht mehr exportieren",
  "rental.planning.exportNote": "frei pro Tag; eine Minuszahl ist die Fehlmenge",
  "rental.portal.readOnly": "Nur lesen — was dieses Gerät meldet",
  "rental.portal.deviceGone": "Dieses Gerät ist nicht mehr bei Ihrer Veranstaltung",
  "rental.portal.noStored": "Für dieses Gerät wurde noch nichts gespeichert",
  "rental.portal.sinceLoaded": "Ab {when}, als es für diese Veranstaltung herausging",
  "rental.portal.unnamedLink": "Unbenannte Verbindung",
  "rental.portal.range1h": "1 Std.",
  "rental.portal.range6h": "6 Std.",
  "rental.portal.cellular": "Mobilfunk",
  "rental.portal.poe": "PoE",
  "rental.portal.standby": "Bereitschaft",
  "rental.portal.unnamedDevice": "Unbenanntes Gerät",
  "rental.pings.title": "Gepingte Geräte",
  "rental.pings.portalTitle": "Ihre Geräte",
  "rental.pings.intro": "Über ihre IP-Adresse über die MikroTik-Funkgeräte Ihrer Veranstaltung gepingt, solange sie läuft.",
  "rental.pings.companyIntro": "Die Geräte des Kunden, über ihre IP-Adresse über die MikroTik-Funkgeräte der laufenden Veranstaltung des Kunden gepingt — nur das Netz dieser Veranstaltung.",
  "rental.pings.name": "Name",
  "rental.pings.ip": "IP-Adresse",
  "rental.pings.state": "Status",
  "rental.pings.rtt": "Antwortzeit",
  "rental.pings.answered": "Zuletzt geantwortet",
  "rental.pings.foundThrough": "Gefunden über",
  "rental.pings.status.ONLINE": "Online",
  "rental.pings.status.OFFLINE": "Offline",
  "rental.pings.status.NO_ANSWER": "Keine Antwort",
  "rental.pings.status.UNKNOWN": "Nicht geprüft",
  "rental.pings.add": "Gerät hinzufügen",
  "rental.pings.edit": "Bearbeiten",
  "rental.pings.save": "Speichern",
  "rental.pings.remove": "Entfernen",
  "rental.pings.removeConfirm": "{name} aus den gepingten Geräten entfernen?",
  "rental.pings.pingNow": "Manuell pingen",
  "rental.pings.pingAll": "Alle pingen",
  "rental.pings.none": "Noch keine Geräte",
  "rental.pings.mode": "Ping-Prüfungen",
  "rental.pings.mode.EVERY_30S": "Alle 30 Sekunden",
  "rental.pings.mode.EVERY_MINUTE": "Jede Minute",
  "rental.pings.mode.EVERY_5_MINUTES": "Alle 5 Minuten",
  "rental.pings.mode.ON_OPEN": "Nur wenn ich das Dashboard öffne",
  "rental.pings.mode.OFF": "Aus",
  "rental.pings.changedBy": "Geändert von {name}, {when}",
  "rental.pings.onOpenLine": "Nur geprüft, solange diese Seite geöffnet ist (höchstens alle 5 Minuten)",
  "rental.pings.notOn": "Derzeit nicht geprüft: keine Veranstaltung des Kunden läuft",
  "rental.pings.answering": "{count} von {total} antworten",
  "rental.pings.failed": "Das hat nicht geklappt",
  "rental.portal.pushPings": "Push, wenn meine Geräte nicht mehr antworten",
  "rental.pings.notOnClient": "Derzeit nicht geprüft: keine Ihrer Veranstaltungen läuft",
  "rental.pings.appliesNow": "Derzeit geprüft als {mode}: die häufigste Einstellung Ihrer laufenden Veranstaltungen",
  "rental.event.openSite": "Standort öffnen",
}

export default rental
